
import Vue from "vue";


export default Vue.extend({
	data(){
		return {

		};
	},
	computed: {
		isChildRoute(){
			return this.$route.path.includes("/plugins/");
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-plugin"
	},
});
